import type { ITotalScoreBgType } from "./types";
import { ITotalScoreColors, ITotalScoreTypes } from "./types";
import { GrayPalette, GreenPalette, RedPalette } from "./palette";

export const getBackgroundColor = (color: ITotalScoreColors, type: ITotalScoreBgType) => {
    const colorMapping: Record<ITotalScoreColors, string> = {
        Green: GreenPalette[type],
        Red: RedPalette[type],
        Gray: GrayPalette[type],
    };

    return colorMapping[color] || GrayPalette[type];
};

export const getTotalScoreColor = (totalScore: ITotalScoreTypes) => {
    const { GROWING, DECLINING } = ITotalScoreTypes;
    const { GREEN, RED, GRAY } = ITotalScoreColors;
    switch (totalScore) {
        case GROWING:
            return GREEN;
        case DECLINING:
            return RED;
        default:
            return GRAY;
    }
};
